import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from '../../../../lib/Colors'
import fonts from '../../../../lib/Font'
import Icon from '../../../shared/Icon'

const Item = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: ${fonts.family.lato};
  font-weight: bold;
  padding: 1em;
  position: relative;
`

const ThumbnailWrapper = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  overflow: hidden;
  margin-right: 8px;
  & img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
  }
`

const FacebookIcon = styled.div`
  position: absolute;
  top: 40px;
  left: 40px;
  background: ${colors.facebook};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ChannelPageItem = (props) => {
  return (
    <Item>
      <ThumbnailWrapper>
        <img alt={props.name} src={props.thumbnail} />
      </ThumbnailWrapper>
      {props.name}
      <FacebookIcon>
        <Icon color={'white'} icon={'facebook'} size={14} />
      </FacebookIcon>
    </Item>
  )
}

ChannelPageItem.propTypes = {
  name: PropTypes.string,
  thumbnail: PropTypes.string,
}

export default ChannelPageItem
